import { useTranslation } from 'react-i18next'

import {
  CampaignCard,
  CampaignCardBody,
  CampaignCardHeader,
  CampaignStat,
} from '#/entities/campaign'
import type { CampaignFigure } from '#/entities/campaign'

interface CampaignEngagementCardProps {
  figures: CampaignFigure[]
  note: string
}

export function CampaignEngagementCard({
  figures,
  note,
}: CampaignEngagementCardProps) {
  const { t } = useTranslation()
  return (
    <CampaignCard>
      <CampaignCardHeader
        label={t('campaigns.detail.sections.emailEngagement')}
      />
      <CampaignCardBody>
        <div className="flex flex-wrap items-start gap-y-4">
          {figures.map((figure) => (
            <CampaignStat
              key={figure.key}
              size="md"
              value={figure.value}
              label={figure.label}
              note={figure.note}
              tone={figure.tone}
            />
          ))}
        </div>
        <div className="flex items-start gap-2.5 rounded-lg bg-gray-100 px-3 py-2.5">
          <span
            aria-hidden="true"
            className="mt-1 size-1.5 shrink-0 rounded-full bg-gray-300"
          />
          <p className="text-xs text-gray-500">{note}</p>
        </div>
      </CampaignCardBody>
    </CampaignCard>
  )
}
